<template>
  <v-container>
    <div v-show="isVisibleProp"></div>
      <WarApprCommon
        :baseCrudKey="baseCrudKey"
        @dialogVal="setDialog"
      />
    <span v-if = "isWarrant">
      <WarrantDetails :baseCrudKey="baseCrudKey"/>
    </span>
    <v-row>
      <v-col cols="3">
        <v-textarea id="edited-item-remarks"
          class="war-trans-item-remarks"
          label="Remarks"
          rows="2"
          v-model="editedItem.remarks"
          v-textAreaUppercase=globalSettingItem.conEverythingToCaps
        ></v-textarea>
      </v-col>
    </v-row>
    <WarApprDetails
      v-model="editedItem.details"
      @latestAmount="fetchAmount"
      @warNo="fetchWarNo"
      @paymentNo="fetchPaymentNo"
      @onChangeFund="onChangeFund"
      :activeTransItem="editedItem"
      :baseCrudKey="baseCrudKey"
    />
  </v-container>
</template>
<script>

import {
  mapGetters,
  mapState,
  mapMutations,
  mapActions,
} from 'vuex';
import WarApprCommon from './WarApprCommon.vue';
import WarApprDetails from './WarApprDetails.vue';
import WarrantDetails from './WarrantDetails.vue';
import WarrantAppropriationsMixin from './WarrantAppropiations.mixin';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'TransactionEditedItem',
  mixins: [WarrantAppropriationsMixin, GlobalToCaps],
  components: {
    WarApprCommon,
    WarApprDetails,
    WarrantDetails,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'war-dialog',
    },
    activeTransItem: {
      type: Object,
      default: () => {},
    },
    attachmentConstants: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    dialog: false,
  }),
  /* eslint-disable func-names */
  watch: {
    'editedItem.status': function () {
      this.nonPayable();
    },
    'editedItem.amount': function () {
      this.nonPayable();
    },
  },
  /* eslint-disable func-names */
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items', 'isVisible']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    isVisibleProp() {
      const isVisible = this.isVisible(this.baseCrudKey);
      if (!isVisible) {
        this.setWarrantRegPolling(undefined);
      } else {
        if (this.editedItem._id) {
          this.loadFiles();
        }
        this.loadFundList();
      }
      return isVisible;
    },
  },
  methods: {
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItem',
    ]),
    ...mapMutations('war/transaction', [
      'setWarrantRegPolling',
    ]),
    amountFormat,
    amountToNumber,
    fetchAmount(value) {
      this.editedItem.amount = amountFormat(value);
    },
    fetchWarNo(value) {
      this.editedItem.warrant = value;
    },
    fetchPaymentNo(value) {
      this.editedItem.payment = value;
    },
    nonPayable() {
      const activeItem = this.item([this.baseCrudKey]);
      if (activeItem.status !== 'PAID' || !activeItem.isNonPayable) return;
      // eslint-disable-next-line max-len
      const activeMatchItem = this.items([this.baseCrudKey]).find((item) => item._id === activeItem._id);
      if (!activeMatchItem || activeMatchItem.amount === undefined) return;
      // eslint-disable-next-line max-len
      const interestAmount = amountToNumber(activeItem.amount) - amountToNumber(activeMatchItem.amount);
      if (amountFormat(activeItem.amount) !== amountFormat(activeMatchItem.amount)) {
        this.editedItem.remarks = `Original Amount: ${amountFormat(activeMatchItem.amount)}\nInterest Amount: ${amountFormat(interestAmount)}`;
      }
    },

    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: this.editedItem._id,
      });
    },
    setDialog(val) {
      this.dialog = val;
    },
    onChangeFund() {
      const fundNumberList = (this.editedItem.details || []).map((item) => {
        const valueType = Object.prototype.toString.call(item.fund);
        let fundNumber = null;
        if (valueType === '[object Object]') {
          fundNumber = (item.fund || {}).fund;
        } else if (valueType === '[object String]') {
          const fundRecord = this.fundListByFyWise.find((fund) => fund._id === item.fund) || {};
          fundNumber = (fundRecord || {}).fund;
        } else {
          /* do nothing */
        }
        return fundNumber;
      });
      /* trigger parent method for action */
      this.$emit('onChangeFund', fundNumberList);
    },
  },
};
</script>
